import imageCompression from "browser-image-compression";
/**compress images 
1. convert base64 to blob using b64toBlob (assuming base64 is image type)
2. returns base 64 compressed image 
3. condition check image type is jpg/png/jpeg
**/

const options = {
  maxSizeMB: 0.5,
  maxWidthOrHeight: 320,
  exifOrientation: 1
}

export const compressImage = base64 => {
  const promise = new Promise(async (resolve, reject) => {
    try {
      const file = await b64toBlob(base64)
      const compressedFile = await imageCompression(file, options)
      const byteArray = await imageCompression.getDataUrlFromFile(compressedFile)
      resolve({ flag: true, byteArray })
    }
    catch {
      reject({ flag: false })
    }
  })
  return promise
}

export const compress = async (base64) => {
  // let {type,imgString} =getBase64TypeAndString(base64)

  let file = await b64toBlob(base64).then(res => {
    // console.log('file: ', file)

    return res;
  }).catch(err => {

    return null;
  });


  return new Promise((resolve, reject) => {
    if (!file) reject(base64);
    let type = file.type.split('/')[1];
    if (/png|jpeg|jpg/gi.test(type)) {

      const options = {
        maxSizeMB: 0.5,
        maxWidthOrHeight: 320,
        exifOrientation: 1,
        onProgress: (i) => {
          //in case you want to add progress bar
        },
      };
      if (800 > (file.size / 1024)) {
        imageCompression.getExifOrientation(file).then(res => {
          console.log(res)
        }).catch(err => {
          console.log(err)
        })
        resolve({ flag: true, byteArray: base64 });
      }
      else {
        imageCompression(file, options)
          .then((compressedFile) => {
            if (800 > (compressedFile.size / 1024)) {
              imageCompression
                .getDataUrlFromFile(compressedFile)
                .then((res) => {

                  resolve({ flag: true, byteArray: res });
                })
                .catch((err) => {
                  reject({ flag: false });
                });
            } else {
              reject({ flag: false });
            }
          })
          .catch((err) => {
            reject({ flag: false });
          });
      }
    }

    else {
      reject({ flag: false })
    }
  });

};

export const getBase64TypeAndString = (base64) => {
  const type = base64.substring(
    base64.indexOf("/") + 1,
    base64.indexOf(";base64")
  );
  const imgString = base64.split(",")[1];
  return { type, imgString };
}
//base64 to blob
const b64toBlob = (b64Data) => {
  return imageCompression.getFilefromDataUrl(b64Data, 'temp')
};
